import apiClient from "@/lib/api-client";
import type {
  BranchRequest,
  ChatThread,
  ChatThreadDetail,
  ChatThreadMessage,
  MessageSaveRequest,
  ThreadCreateRequest,
} from "@/types/thread";

export async function listThreads(conceptId: string): Promise<ChatThread[]> {
  return apiClient
    .get(`api/concepts/${conceptId}/chat/threads`)
    .json<ChatThread[]>();
}

export async function createThread(
  conceptId: string,
  data: ThreadCreateRequest,
): Promise<ChatThread> {
  return apiClient
    .post(`api/concepts/${conceptId}/chat/threads`, { json: data })
    .json<ChatThread>();
}

export async function getThread(
  conceptId: string,
  threadId: string,
): Promise<ChatThreadDetail> {
  return apiClient
    .get(`api/concepts/${conceptId}/chat/threads/${threadId}`)
    .json<ChatThreadDetail>();
}

export async function updateThread(
  conceptId: string,
  threadId: string,
  data: { title: string },
): Promise<ChatThread> {
  return apiClient
    .patch(`api/concepts/${conceptId}/chat/threads/${threadId}`, { json: data })
    .json<ChatThread>();
}

export async function deleteThread(
  conceptId: string,
  threadId: string,
): Promise<void> {
  await apiClient.delete(`api/concepts/${conceptId}/chat/threads/${threadId}`);
}

export async function clearAllThreads(conceptId: string): Promise<void> {
  await apiClient.delete(`api/concepts/${conceptId}/chat/threads`);
}

export async function saveMessages(
  conceptId: string,
  threadId: string,
  data: MessageSaveRequest,
): Promise<ChatThreadMessage[]> {
  return apiClient
    .post(`api/concepts/${conceptId}/chat/threads/${threadId}/messages`, {
      json: data,
    })
    .json<ChatThreadMessage[]>();
}

export async function branchThread(
  conceptId: string,
  threadId: string,
  data: BranchRequest,
): Promise<ChatThreadDetail> {
  return apiClient
    .post(`api/concepts/${conceptId}/chat/threads/${threadId}/branch`, {
      json: data,
    })
    .json<ChatThreadDetail>();
}
